import type { SVGProps } from 'react';

export function CalendarIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M5.33333 1.33333V2.66677M5.33333 2.66677V4.00021M5.33333 2.66677H3.33333C2.59695 2.66677 2 3.26377 2 4.00021V6.66709M5.33333 2.66677H10.6667M10.6667 1.33333V2.66677M10.6667 2.66677V4.00021M10.6667 2.66677H12.6667C13.403 2.66677 14 3.26377 14 4.00021V6.66709M2 6.66709H14M2 6.66709V13.3343C2 14.0707 2.59695 14.6677 3.33333 14.6677H12.6667C13.403 14.6677 14 14.0707 14 13.3343V6.66709"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
